import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";

import type { CartIndicatorType } from "modules/Appointments/queryKeys";

export const useCartIndicatorsToFilter = () => useTypedQuery({ queryKey: AppointmentsQueryKeys.cartIndicatorsToFilter, initialData: {} }).data;
export const setCartIndicatorsToFilter = (cartIndicators: CartIndicatorType) =>
  typedQueryClient.setQueryData(AppointmentsQueryKeys.cartIndicatorsToFilter, cartIndicators);
